import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { HelpBlock } from 'react-bootstrap';
import masterField from '../../../../../components/search-form/master-field';
import renderField from './render-field';

const lookbackPeriods = [
  { value: '1 days', label: 'One Day' },
  { value: '1 weeks', label: 'One Week' },
  { value: '2 weeks', label: 'Two Weeks' },
  { value: '1 months', label: 'One Month' },
  { value: '3 months', label: 'Three Month' },
  { value: '6 months', label: 'Six Month' },
  { value: '12 months', label: 'One Year' },
];

class ReminderLookbackField extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    return (
      <div>
        <Field
          name="lookback_period"
          componentClass="select"
          options={lookbackPeriods}
          component={renderField}
          disabled={this.props.disabled}
        />
        <HelpBlock>Only opportunity closed within the lookback period will be considered.</HelpBlock>
      </div>
    );
  }
}

ReminderLookbackField.propTypes = {
  value: PropTypes.string,
  disabled: PropTypes.bool,
  submitting: PropTypes.bool,
  onChange: PropTypes.func,
};
ReminderLookbackField.defaultProps = {
  value: null,
  disabled: false,
  submitting: false,
};
export default masterField(ReminderLookbackField);
